/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable max-params */

// Fast match util — avoids extra function calls
const isMatch = (f, fk, ok, sok) =>
    f.filterKey === fk &&
  (!ok || f.optionKey === ok) &&
  (!sok || f.subOptionKey === sok);

// Avoid object spread, keep logic flat and imperative
export const checkIfFilterExists = ({ filterKey, optionKey, subOptionKey, isRangeFilter }, selectedFilters = []) => {
    if (isRangeFilter) return false;

    for (let i = 0; i < selectedFilters.length; i++) {
        const f = selectedFilters[i];
        if (isMatch(f, filterKey, optionKey, subOptionKey)) return true;
    }
    return false;
};

const addFilter = (params, selectedFilters) => {
    if (checkIfFilterExists(params, selectedFilters)) return selectedFilters;

    const {
        filterKey, optionKey, subOptionKey, displayText,
        isRangeFilter, rangeValues, spath, subFilterKey, displayName
    } = params;
    const newFilter = { filterKey, displayText };

    if (optionKey) newFilter.optionKey = optionKey;
    if (subOptionKey) newFilter.subOptionKey = subOptionKey;
    if (isRangeFilter && rangeValues) {
        newFilter.isRangeFilter = true;
        newFilter.min = rangeValues.min;
        newFilter.max = rangeValues.max;
    }
    if (displayName) newFilter.displayName = displayName;
    if (spath) newFilter.spath = spath;
    if (subFilterKey) newFilter.subFilterKey = subFilterKey;
    const len = selectedFilters.length;
    const updated = new Array(len + 1);
    for (let i = 0; i < len; i++) updated[i] = selectedFilters[i];
    updated[len] = newFilter;
    return updated;
};

const removeFilter = ({ filterKey, optionKey, subOptionKey }, selectedFilters) => {
    const result = [];
    for (let i = 0; i < selectedFilters.length; i++) {
        const f = selectedFilters[i];
        if (!isMatch(f, filterKey, optionKey, subOptionKey)) {
            result.push(f);
        }
    }
    return result;
};

const getUpdatedAppliedFilters = (
    {
        filterKey, optionKey, subOptionKey, isSelected,
        displayText, isRangeFilter, rangeValues,
        isSingleEntity, isAllModelVariant = false, spath, subFilterKey, displayName
    },
    selectedFilters
) => {
    if (isRangeFilter || isSingleEntity) {
        if (!isSelected) return removeFilter({ filterKey, optionKey, subOptionKey }, selectedFilters);

        const filtered = removeFilter({ filterKey }, selectedFilters);
        return addFilter({ filterKey, optionKey, subOptionKey, displayText, isRangeFilter, rangeValues, spath, subFilterKey, displayName }, filtered);
    }

    if (isSelected) {
        let updated = selectedFilters;

        if (isAllModelVariant) {
            for (let i = 0; i < updated.length; i++) {
                const f = updated[i];
                if (f.optionKey === optionKey && !f.subOptionKey) {
                    updated = removeFilter({ filterKey, optionKey: f.optionKey }, updated);
                    break;
                }
            }
        }

        return addFilter({ filterKey, optionKey, subOptionKey, displayText, isRangeFilter, rangeValues, spath, subFilterKey, displayName }, updated);
    }

    return removeFilter({ filterKey, optionKey, subOptionKey }, selectedFilters);
};

export const getUpdatedSubFilterOptions = ({
    filterKey, optionKey, isSelected,
    selectedFilters, displayText,
    allFilters, isAllModelVariant = false
}) => {
    const selectedFilter = allFilters[filterKey];
    if (!selectedFilter) return selectedFilters;

    const selectedOption = selectedFilter.options?.find(o => o.key === optionKey);
    const subOptions = selectedOption?.subFilter?.options || [];

    let updated = selectedFilters;

    if (isAllModelVariant && filterKey === "make") {
    // remove all sub-options for this optionKey
        const result = [];
        for (let i = 0; i < updated.length; i++) {
            const f = updated[i];
            if (f.filterKey !== filterKey || f.optionKey !== optionKey) {
                result.push(f);
            }
        }

        return isSelected
            ? addFilter({ filterKey, optionKey, subOptionKey: "", displayText }, result)
            : result;
    }

    for (let i = 0; i < subOptions.length; i++) {
        const sub = subOptions[i];
        const filterParams = {
            filterKey,
            optionKey,
            subOptionKey: sub.key,
            displayText: sub.displayText
        };

        updated = isSelected
            ? addFilter(filterParams, updated)
            : removeFilter(filterParams, updated);
    }

    return updated;
};

export default getUpdatedAppliedFilters;
